import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Brand = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700;
  font-size: 1.35rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fonts.en};
  text-decoration: none;
  flex-shrink: 1;
  min-width: 0;
  max-width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    gap: 10px;
    font-size: 1.2rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    gap: 8px;
    font-size: 1rem;
  }
`;

const LogoImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  object-fit: contain;
  object-position: center;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.16);
  flex-shrink: 0;
  display: block;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 40px;
    height: 40px;
  }
`;

const CompanyName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: 0.9em;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 0.85em;
  }
`;

const Logo = () => (
  <Brand to="/" aria-label="الرئيسية">
    <LogoImage src="/Macintosh-HD.png" alt="AMER COMPANY Logo" />
    <CompanyName>AMER COMPANY</CompanyName>
  </Brand>
);

export default Logo;
